import { render, staticRenderFns } from "./RetailerDetailsPage.vue?vue&type=template&id=42e05db3&"
import script from "./RetailerDetailsPage.vue?vue&type=script&lang=js&"
export * from "./RetailerDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports